/* Brainy Bounce · "Catch Bo & Save!" floating reward.
   One button opens the reward panel. The discount itself is a real Shopify code from Theme settings;
   Shopify enforces eligibility. sessionStorage only remembers "hidden for this visit". */
(function () {
  'use strict';
  function boot(root) {
    if (!root || root.__bb) return; root.__bb = true;
    var catchBtn = root.querySelector('[data-cb-catch]'), dismissBtn = root.querySelector('[data-cb-dismiss]');
    var dialog = root.querySelector('[data-cb-dialog]'), closeBtn = root.querySelector('[data-cb-close]');
    var copyBtn = root.querySelector('[data-cb-copy]'), applyBtn = root.querySelector('[data-cb-apply]');
    var statusEl = root.querySelector('[data-cb-status]'), codeIn = root.querySelector('#bb-cb-code');
    var confetti = root.querySelector('[data-cb-confetti]');
    var code = root.getAttribute('data-code'), base = (root.getAttribute('data-root') || '/').replace(/\/$/, '');
    function still() { return document.documentElement.classList.contains('bb-still') || window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    function get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
    function set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

    if (get('bb-cb-hidden') === '1') { root.hidden = true; return; }

    // ---- open / close the reward panel ----
    function open() {
      if (statusEl) statusEl.textContent = '';   // no status line in automatic (no-code) mode
      if (dialog.showModal) { if (!dialog.open) dialog.showModal(); } else dialog.setAttribute('open', '');
      (copyBtn && !copyBtn.disabled ? copyBtn : closeBtn).focus();
    }
    function close() { if (dialog.open) { if (dialog.close) dialog.close(); else dialog.removeAttribute('open'); } }
    dialog.addEventListener('close', function () { catchBtn.focus(); });   // Escape + close button both land here
    root.querySelectorAll('[data-cb-close]').forEach(function (b) { b.addEventListener('click', close); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });

    catchBtn.addEventListener('click', function () {     // mouse, touch, Enter and Space (native button)
      if (!still()) {
        root.classList.remove('is-caught'); void root.offsetWidth; root.classList.add('is-caught');
        burst();
      }
      open();    // immediately, never waits on the animation
    });
    dismissBtn.addEventListener('click', function () { set('bb-cb-hidden', '1'); root.hidden = true; });

    function burst() {
      var cols = ['#ff2e93', '#b6f23a', '#2fe0d6', '#ffd23f', '#b9a4ff'];
      for (var i = 0; i < 14; i++) {
        var p = document.createElement('span'), a = (i / 14) * Math.PI * 2, d = 50 + Math.random() * 40;
        p.className = 'bb-cb__bit'; p.style.background = cols[i % 5];
        p.style.setProperty('--x', Math.cos(a) * d + 'px'); p.style.setProperty('--y', Math.sin(a) * d - 20 + 'px');
        confetti.appendChild(p); setTimeout(function (n) { return function () { n.remove(); }; }(p), 800);
      }
    }

    // ---- copy / apply (only claim success when it really happened) ----
    if (copyBtn) copyBtn.addEventListener('click', function () {
      function ok() { statusEl.textContent = 'Copied! Paste it at checkout: ' + code; }
      function fallback() { codeIn.focus(); codeIn.select(); try { if (document.execCommand('copy')) ok(); else throw 0; } catch (e) { statusEl.textContent = 'Select the code above and copy it.'; } }
      if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(ok, fallback); else fallback();
    });
    if (applyBtn) applyBtn.addEventListener('click', function () {
      if (applyBtn.dataset.done) { close(); return; }
      applyBtn.disabled = true; statusEl.textContent = 'Applying…';
      fetch(base + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(base + '/cart.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function () { return fetch(base + '/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var hit = (cart.discount_codes || []).filter(function (d) { return String(d.code).toLowerCase() === code.toLowerCase(); })[0];
          if (hit && hit.applicable) statusEl.textContent = 'Applied to your cart. You’ll see it at checkout.';
          else if (hit || cart.item_count === 0) statusEl.textContent = 'Saved for checkout. Shopify will apply it if your order qualifies.';
          else throw new Error('not confirmed');
          applyBtn.dataset.done = '1'; applyBtn.textContent = 'Keep shopping';
        })
        .catch(function () { statusEl.textContent = 'We couldn’t apply it automatically. Copy the code and enter it at checkout.'; })
        .finally(function () { applyBtn.disabled = false; });
    });

    // ---- stay out of the way: hide under cart drawers / dialogs, lift above chat bubbles ----
    // never sit on top of the hero toy basket (a drop target): fade out while it's underneath
    function onBasket() {
      var b = document.querySelector('[data-bb-basket]'); if (!b) return false;
      var r = b.getBoundingClientRect(), c = root.getBoundingClientRect(), m = 10;
      return r.width > 0 && !(r.right < c.left - m || r.left > c.right + m || r.bottom < c.top - m || r.top > c.bottom + m);
    }
    function sync() {
      var modal = Array.prototype.some.call(document.querySelectorAll('dialog[open], cart-drawer[open], [aria-modal="true"]'), function (el) {
        if (root.contains(el)) return false;
        return el.tagName === 'DIALOG' || el.getClientRects().length > 0;
      });
      root.classList.toggle('is-covered', modal || onBasket());
      var lift = 0;
      document.querySelectorAll('#shopify-chat, inbox-online-store-chat, #ShopifyChat, [id*="chat-button"], .shopify-pc__banner__dialog, #shopify-pc__banner').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.width && r.height && r.right > window.innerWidth - 220 && r.bottom > window.innerHeight - 220) lift = Math.max(lift, window.innerHeight - r.top + 8);
      });
      root.style.setProperty('--cb-lift', lift + 'px');
    }
    var mo = new MutationObserver(function () { clearTimeout(mo.t); mo.t = setTimeout(sync, 60); });
    mo.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['open', 'aria-modal', 'class', 'hidden'] });
    var st = 0; function onScroll() { if (!st) st = requestAnimationFrame(function () { st = 0; sync(); }); }
    window.addEventListener('resize', sync); window.addEventListener('scroll', onScroll, { passive: true }); sync();
    root.__bbDispose = function () { mo.disconnect(); window.removeEventListener('resize', sync); window.removeEventListener('scroll', onScroll); };
  }
  function init() { document.querySelectorAll('[data-bb-catchbo]').forEach(boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
